
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(2154|4320|92698)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
